import { render, staticRenderFns } from "./UpdateAvatar.vue?vue&type=template&id=7093753d&"
import script from "./UpdateAvatar.vue?vue&type=script&lang=js&"
export * from "./UpdateAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports